import { localDate } from "@shared/forecast";

/** Find the actual next local date boundary, not now + 24h or a fixed UTC offset. */
export function nextForecastDateChange(now: number, timezone: string): number {
  const today = localDate(now, timezone);
  let low = now;
  let high = now + 48 * 60 * 60 * 1000;
  while (high - low > 1) {
    const middle = Math.floor((low + high) / 2);
    if (localDate(middle, timezone) === today) low = middle;
    else high = middle;
  }
  return high;
}

export function forecastLocalDate(timezone?: string): string | null {
  if (!timezone) return null;
  try {
    return localDate(Date.now(), timezone);
  } catch {
    // Missing/invalid model timezone must not silently become the viewer's timezone.
    return null;
  }
}
